import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PrescriptionSourceTypeEnum } from 'src/app/enums/prescription-source-type.enum';
import { showNotification } from 'src/app/helpers/show-toast';
import { IEmrPrescriptionDetails } from 'src/app/_interfaces/patients/i-emr-prescription-details';
import { PatientEmrDetailsService } from 'src/app/_services/patient-emr/patient-emr-details.service';

@Component({
  selector: 'app-emr-prescription-details',
  templateUrl: './emr-prescription-details.component.html',
  styleUrls: ['./emr-prescription-details.component.scss'],
})
export class EmrPrescriptionDetailsComponent implements OnInit {
  patientId: number;
  prescriptionId: number;
  prescriptionSourceType: number;
  prescriptionDetails: IEmrPrescriptionDetails;
  prescriptionFiles: string[] = [];
  prescriptionFilesAsImages: string[] = [];
  prescriptionFilesAsPDFs: string[] = [];

  constructor(
    private patientEmrDetailsService: PatientEmrDetailsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.patientId = +this.activatedRoute.snapshot.params.patientId;
    this.prescriptionId = +this.activatedRoute.snapshot.params.prescriptionId;
    this.prescriptionSourceType =
      +this.activatedRoute.snapshot.params.prescriptionSourceType;

    if (
      this.prescriptionSourceType == this.prescriptionSourceTypeEnum.details
    ) {
      this.getPatientEmrPrescriptionDetails(
        this.prescriptionId,
        this.patientId
      );
    } else if (
      +this.prescriptionSourceType == this.prescriptionSourceTypeEnum.files
    ) {
      this.getPatientEmrPrescriptionFiles(this.prescriptionId, this.patientId);
    } else {
      showNotification(
        'danger',
        'Something went wrong with source type!',
        this.toastr
      );
    }
  }

  get prescriptionSourceTypeEnum() {
    return PrescriptionSourceTypeEnum;
  }

  getPatientEmrPrescriptionDetails(prescriptionId, patientId) {
    this.patientEmrDetailsService
      .getPatientEhrPrescriptionDetails(prescriptionId, patientId)
      .subscribe(
        (response) => {
          this.prescriptionDetails = response.data;
        },
        (error) => {
          showNotification(
            'danger',
            `${
              error.error
                ? error?.error?.errorList[0]?.message
                : error?.errors?.title
            }`,
            this.toastr
          );
        }
      );
  }

  getPatientEmrPrescriptionFiles(prescriptionId, patientId) {
    this.patientEmrDetailsService
      .getPatientEhrPrescriptionFiles(prescriptionId, patientId)
      .subscribe(
        (response) => {
          this.prescriptionFiles = response.data?.attachmentUrls;

          if (this.prescriptionFiles?.length) {
            this.prescriptionFiles.forEach((file) => {
              if (this.checkFileType(file)) {
                this.prescriptionFilesAsPDFs.push(file);
              } else {
                this.prescriptionFilesAsImages.push(file);
              }
            });
          }
        },
        (error) => {
          showNotification(
            'danger',
            `${
              error.error
                ? error?.error?.errorList[0]?.message
                : error?.errors?.title
            }`,
            this.toastr
          );
        }
      );
  }

  checkFileType(src) {
    const pattern = /.+.pdf$/;
    return pattern.test(src);
  }

  downloadFile(fileUrl) {
    this.patientEmrDetailsService.downloadFile(fileUrl, (response) => {
      let fileName = fileUrl.split('/').pop();
      let a = document.createElement('a');
      let objectUrl = URL.createObjectURL(response);
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }
}
